module.exports = __webpack_public_path__ + "static/media/360-tours-inactive.39119218.svg";